import { render, staticRenderFns } from "./GenderSection.vue?vue&type=template&id=7fd7316f&scoped=true&"
import script from "./GenderSection.vue?vue&type=script&lang=js&"
export * from "./GenderSection.vue?vue&type=script&lang=js&"
import style0 from "./GenderSection.vue?vue&type=style&index=0&id=7fd7316f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd7316f",
  null
  
)

export default component.exports